module.exports = __webpack_public_path__ + "static/assets/af5cafbff5e8c2ccbb54e08031cf1845.png";